// import React, { useState, useEffect } from 'react';
// import Sidebar from '../components/Sidebar';
// import {
//   Grid,
//   Typography,
//   Box,
//   Badge,
//   IconButton,
//   Modal,
//   List,
//   ListItem,
//   ListItemText,
//   CircularProgress,
// } from '@mui/material';
// import NotificationsIcon from '@mui/icons-material/Notifications';
// import CloseIcon from '@mui/icons-material/Close';
// import Cards from '../components/Cards';
// import CompanyCards from '../components/CompanyCards';
// import Chart from '../components/Chart';
// import ReminderList from '../components/ReminderList';
// import CustomCalendar from '../components/Calendar';
// import img from '../assets/banner.jpg';

// import {
//   getStats as getCompanyStats,
//   getInsuranceReminders,
//   getLoanReminders,
//   getUtilityReminders,
//   getRentReminders,
//   verifyToken,
// } from '../api';

// function Dashboard() {
//   const [user, setUser] = useState(null);
//   const [open, setOpen] = useState(false);
//   const [stats, setStats] = useState({});
//   const [companyStats, setCompanyStats] = useState({});
//   const [reminders, setReminders] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchDashboardData = async () => {
//       try {
//         const profile = await verifyToken();
//         setUser(profile);

//         const companyStatsData = await getCompanyStats();
//         const insurance = await getInsuranceReminders();
//         const loans = await getLoanReminders();
//         const utility = await getUtilityReminders();
//         const rents = await getRentReminders();

//         setCompanyStats(companyStatsData);
//         setReminders([...insurance, ...loans, ...utility, ...rents]);
//       } catch (error) {
//         console.error('Dashboard Load Error:', error.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchDashboardData();
//   }, []);

//   return (
//     <Box
//       display="flex"
//       sx={{
//         minHeight: '100vh',
//         backgroundImage: `url(${img})`,
//         backgroundSize: 'cover',
//         backgroundRepeat: 'no-repeat',
//         backgroundPosition: 'center',
//       }}
//     >
//       <Sidebar />

//       <Box flexGrow={1} ml={25} p={4}>
//         <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
//           <Typography variant="h5" fontWeight={600}>
//             Welcome back{user?.username ? `, ${user.username}` : '!'}
//           </Typography>

//           <IconButton onClick={() => setOpen(true)}>
//             <Badge badgeContent={reminders.length} color="error">
//               <NotificationsIcon sx={{ color: '#e0b256' }} />
//             </Badge>
//           </IconButton>
//         </Box>

//         {loading ? (
//           <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
//             <CircularProgress />
//           </Box>
//         ) : (
//           <>
//             {/* First Row: Cards (side by side) */}
//             <Grid container spacing={3} justifyContent="space-between">
//               <Cards stats={companyStats} />
//             </Grid>

//             {/* Second Row: CompanyCards (side by side) */}
//             <Grid container spacing={3} mt={2} justifyContent="space-between">
//               <CompanyCards />
//             </Grid>

//             {/* Third Row: ReminderList and Calendar side by side */}
//             <Grid container spacing={4} mt={2}>
//               <Grid item xs={12} md={6} sx={{ padding: 1 }}>
//                 <ReminderList reminders={reminders} />
//               </Grid>
//               <Grid item xs={12} md={6} sx={{ padding: 1 }}>
//                 <CustomCalendar reminders={reminders} />
//               </Grid>
//             </Grid>

//             {/* Fourth Row: Chart (full width) */}
//             <Grid container spacing={3} mt={2}>
//               <Grid item xs={12}>
//                 <Chart stats={companyStats} />
//               </Grid>
//             </Grid>
//           </>
//         )}
//       </Box>

//       <Modal open={open} onClose={() => setOpen(false)}>
//         <Box
//           sx={{
//             position: 'absolute',
//             top: 20,
//             right: 40,
//             width: 320,
//             bgcolor: '#121212',
//             borderRadius: 2,
//             boxShadow: 24,
//             p: 3,
//             outline: 'none',
//             color: '#fff',
//             maxHeight: '80vh',
//             overflowY: 'auto',
//           }}
//         >
//           <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//             <Typography variant="h6" fontWeight={600}>
//               Notifications
//             </Typography>
//             <IconButton onClick={() => setOpen(false)} sx={{ color: '#fff' }}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//           <List>
//             {reminders.map((reminder, index) => (
//               <ListItem key={index} divider>
//                 <ListItemText
//                   primary={`Reminder: ${
//                     reminder.policy_number ||
//                     reminder.loan_name ||
//                     reminder.bill_name ||
//                     reminder.rent_name ||
//                     'Upcoming due'
//                   }`}
//                   secondary={`Due Date: ${
//                     reminder.period_to ||
//                     reminder.maturity_date ||
//                     reminder.due_date ||
//                     reminder.payment_due_date
//                   }`}
//                 />
//               </ListItem>
//             ))}
//           </List>
//         </Box>
//       </Modal>
//     </Box>
//   );
// }

// export default Dashboard;

import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import {
  Grid,
  Typography,
  Box,
  Badge,
  IconButton,
  Modal,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
} from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import CloseIcon from '@mui/icons-material/Close';
import Cards from '../components/Cards';
import CompanyCards from '../components/CompanyCards';
import Chart from '../components/Chart';
import ReminderList from '../components/ReminderList';
import CustomCalendar from '../components/Calendar';
import img from '../assets/banner.jpg';

import {
  getStats as getCompanyStats,
  getInsuranceReminders,
  getLoanReminders,
  getUtilityReminders,
  getRentReminders,
  verifyToken,
} from '../api';

function Dashboard() {
  const [user, setUser] = useState(null);
  const [open, setOpen] = useState(false);
  const [stats, setStats] = useState({});
  const [companyStats, setCompanyStats] = useState({});
  const [reminders, setReminders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const profile = await verifyToken();
        setUser(profile);

        const companyStatsData = await getCompanyStats();
        const insurance = await getInsuranceReminders();
        const loans = await getLoanReminders();
        const utility = await getUtilityReminders();
        const rents = await getRentReminders();

        setCompanyStats(companyStatsData);
        setReminders([...insurance, ...loans, ...utility, ...rents]);
      } catch (error) {
        console.error('Dashboard Load Error:', error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  return (
    <Box
      display="flex"
      sx={{
        minHeight: '100vh',
        backgroundImage: `url(${img})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}
    >
      <Sidebar />

      <Box flexGrow={1} ml={25} p={4}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
          <Typography variant="h5" fontWeight={600}>
            Welcome back{user?.username ? `, ${user.username}` : '!'}
          </Typography>

          <IconButton onClick={() => setOpen(true)}>
            <Badge badgeContent={reminders.length} color="error">
              <NotificationsIcon sx={{ color: '#e0b256' }} />
            </Badge>
          </IconButton>
        </Box>

        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
            <CircularProgress />
          </Box>
        ) : (
          <>
            {/* First Row: Cards (side by side) */}
            <Grid container spacing={3} justifyContent="space-between">
              <Cards stats={companyStats} />
            </Grid>

            {/* Second Row: CompanyCards (side by side) */}
            <Grid container spacing={3} mt={2} justifyContent="space-between">
              <CompanyCards />
            </Grid>

            {/* Third Row: ReminderList (70%) and Calendar (30%) side by side */}
       <Grid container spacing={4} mt={2}>
  <Grid item xs={12} md={7} sx={{ padding: 1 }}>
    <ReminderList reminders={reminders} />
  </Grid>
  <Grid item xs={12} md={5} sx={{ padding: 1,ml:65 }}>
    <CustomCalendar reminders={reminders} />
  </Grid>
</Grid>


            {/* Fourth Row: Chart (full width) */}
            <Grid container spacing={3} mt={2}>
              <Grid item xs={12}>
                <Chart stats={companyStats} />
              </Grid>
            </Grid>
          </>
        )}
      </Box>

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: 'absolute',
            top: 20,
            right: 40,
            width: 320,
            bgcolor: '#121212',
            borderRadius: 2,
            boxShadow: 24,
            p: 3,
            outline: 'none',
            color: '#fff',
            maxHeight: '80vh',
            overflowY: 'auto',
          }}
        >
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h6" fontWeight={600}>
              Notifications
            </Typography>
            <IconButton onClick={() => setOpen(false)} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <List>
            {reminders.map((reminder, index) => (
              <ListItem key={index} divider>
                <ListItemText
                  primary={`Reminder: ${
                    reminder.policy_number ||
                    reminder.loan_name ||
                    reminder.bill_name ||
                    reminder.rent_name ||
                    'Upcoming due'
                  }`}
                  secondary={`Due Date: ${
                    reminder.period_to ||
                    reminder.maturity_date ||
                    reminder.due_date ||
                    reminder.payment_due_date
                  }`}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Modal>
    </Box>
  );
}

export default Dashboard;